import React from "react";
import { Hammer, Route, Waves, Trash2, Move, RotateCw, Hand, Plane, Plus, Minus, Maximize } from "lucide-react";
import { C, FONT_BODY } from "./theme";

// Dock tools melayang (kanan tengah canvas): mode editor + lebar jalan saat mode Jalan
export function ToolsDock({ mode, onMode, roadWidth, onRoadWidth }) {
  return (
      <div data-testid="tools-dock" style={{ position: "absolute", right: 26, top: "50%", transform: "translateY(-50%)", display: "flex", flexDirection: "column", gap: 3, zIndex: 10, background: "#fff", borderRadius: 99, padding: 6, boxShadow: "0 10px 26px rgba(20,20,20,0.14)" }}>
        {[
          ["build", Hammer, "Bangunan — pilih aset di katalog kiri", "mode-build"],
          ["road", Route, "Jalan & Transportasi — seret untuk menggambar", "mode-road"],
          ["runway", Plane, "Landasan Pacu — seret untuk menggambar landasan lebar 2 tile", "mode-runway"],
          ["water", Waves, "Lanskap & Air — seret untuk menggambar", "mode-water"],
          ["erase", Trash2, "Hapus / Demolish — klik gedung, jalan, atau sungai", "mode-erase"],
          ["move", Move, "Pindah / Relokasi — klik gedung lalu klik tujuan", "mode-move"],
          ["rotate", RotateCw, "Putar — klik gedung untuk memutar 90°", "mode-rotate"],
          ["pan", Hand, "Geser Peta — seret untuk menggeser", "mode-pan"],
        ].map(([m, Icon, label, tid]) => (
          <button key={m} data-testid={tid} title={label} onClick={() => onMode(m)}
            style={{ width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", border: 0, borderRadius: "50%", cursor: "pointer",
              background: mode === m ? C.ink : "transparent", color: mode === m ? "#fff" : C.ink, transition: "background-color 0.15s" }}
            onMouseEnter={e => { if (mode !== m) e.currentTarget.style.background = C.hoverBg; }}
            onMouseLeave={e => { if (mode !== m) e.currentTarget.style.background = "transparent"; }}>
            <Icon size={16} color={mode === m ? "#6a6aff" : C.ink} />
          </button>
        ))}
        {mode === "road" && (
          <>
            <div style={{ height: 1, background: C.line, margin: "3px 8px" }} />
            {[[1, "Gang — 1 tile"], [2, "Jalan Raya — 2 tile"]].map(([w, label]) => (
              <button key={w} data-testid={w === 1 ? "road-width-1" : "road-width-toggle"} title={label} onClick={() => onRoadWidth(w)}
                style={{ width: 40, height: 32, display: "flex", alignItems: "center", justifyContent: "center", border: 0, borderRadius: 99, cursor: "pointer",
                  fontSize: 12, fontWeight: 800, fontFamily: FONT_BODY, background: roadWidth === w ? C.blue : "transparent", color: roadWidth === w ? "#fff" : C.sub, transition: "background-color 0.15s" }}>
                {w}
              </button>
            ))}
          </>
        )}
      </div>
  );
}

// Kontrol zoom melayang (kanan bawah canvas)
export function ZoomDock({ onZoomIn, onZoomOut, onFit }) {
  return (
      <div style={{ position: "absolute", bottom: 26, right: 26, display: "flex", flexDirection: "column", gap: 4, zIndex: 10, background: "#fff", borderRadius: 99, padding: 6, boxShadow: "0 10px 26px rgba(20,20,20,0.14)" }}>
        {[
          { Icon: Plus, fn: onZoomIn, id: "zoom-in-btn", label: "Perbesar" },
          { Icon: Minus, fn: onZoomOut, id: "zoom-out-btn", label: "Perkecil" },
          { Icon: Maximize, fn: onFit, id: "reset-view-btn", label: "Reset tampilan" },
        ].map(({ Icon, fn, id, label }) => (
          <button key={id} data-testid={id} onClick={fn} title={label}
            style={{ width: 38, height: 38, display: "flex", alignItems: "center", justifyContent: "center", background: "transparent", border: 0, borderRadius: "50%", color: C.ink, transition: "background-color 0.15s" }}
            onMouseEnter={e => e.currentTarget.style.background = C.hoverBg}
            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
            <Icon size={16} />
          </button>
        ))}
      </div>
  );
}
